export let hasLocalStorageSupport;
try {
    hasLocalStorageSupport = 'localStorage' in window && window.localStorage !== null;
    const testKey = 'pascalprecht.translate.storageTest';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
}
catch (e) {
    hasLocalStorageSupport = false;
}
export let loginId;
export let userContextId;
export let secret;
/**
 * Set the login id which will be used for setting and getting user's localstorage values
 */
export const setLoginIdForLocalStorage = (id) => {
    loginId = id;
};
/**
 * Set the user's context id which will be used for setting and getting user context's localstorage values
 */
export const setUserContextIdForLocalStorage = (id) => {
    userContextId = id;
};
/**
 * Get the login id of the logged-in user, which the app sets once the account has loaded
 */
export const getLoginIdForLocalStorage = () => loginId;
/**
 * Clear the login id which will be used for setting and getting user's localstorage values
 */
export const clearLoginIdForLocalStorage = () => {
    loginId = undefined;
};
/**
 * Clear the user's context id which will be used for setting and getting user context's localstorage values
 */
export const clearUserContextIdForLocalStorage = () => {
    userContextId = undefined;
};
/**
 * Set the secret for en-/decrypting values in localstorage
 */
export const setSecretForLocalStorage = (key) => {
    secret = key;
};
/**
 * Clear the secret for en-/decrypting values in localstorage
 */
export const clearSecretForLocalStorage = () => {
    secret = undefined;
};
